export default "__VITE_ASSET__CMhF2FgG__"